"use client";

import { AddressInputSearch } from "@/app/[lng]/_components/Forms/address-input-search";
import { useTranslation } from "@/app/i18n/client";
import { LocaleName } from "@/app/i18n/settings";
import { useMapLocationContext } from "@/utils/contexts/map-location-context";

type Props = {
  lng: LocaleName;
};

export default function MapLocationSearch({ lng }: Props) {
  const { t } = useTranslation("buspartners");
  const addrContext = useMapLocationContext();
  return (
    <AddressInputSearch
      lng={lng}
      id={"Tipps"}
      type="locality"
      placeholder={t("BRMAP.SEARCH.PLACEHOLDER")}
      onAddressChange={(addr) =>
        addrContext.setAddressWithLocation(addr ?? null)
      }
      className="mx-auto max-w-full lg:max-w-[500px]"
    />
  );
}
